module.exports = __webpack_public_path__ + "img/icon_profile_active_mob.cb577629.svg";